import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import UserProfileForm from '@/components/user/UserProfileForm';
import UpdatePasswordForm from '@/components/user/UpdatePasswordForm';

const UserAccountPage = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">User Account</h1>
      <p className="text-muted-foreground">Manage your profile settings and account preferences.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Profile Information</CardTitle>
          </CardHeader>
          <CardContent>
            <UserProfileForm />
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Change Password</CardTitle>
          </CardHeader>
          <CardContent>
            <UpdatePasswordForm />
          </CardContent>
        </Card>

        {/* You can add more cards for other settings here */}
      </div>
    </div>
  );
};

export default UserAccountPage; 